import { useEffect, useState } from "react";
import { PARISH_ATTENDANCE_URL } from "@/data/links";

export const to12h = (t) => {
  if (!t) return "";
  const [h, m] = t.split(":").map(Number);
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`;
};

export const registerUrl = (m) => `${PARISH_ATTENDANCE_URL}/m/${m.id}`;

export function useOpenMeetings() {
  const [meetings, setMeetings] = useState([]);
  useEffect(() => {
    fetch(`${PARISH_ATTENDANCE_URL}/api/public/open-meetings`)
      .then((r) => (r.ok ? r.json() : []))
      .then((d) => setMeetings(Array.isArray(d) ? d.filter((m) => m.status === "open") : []))
      .catch(() => setMeetings([]));
  }, []);
  return meetings;
}

const toMinutes = (t) => {
  const m = /^(\d{1,2}):(\d{2})\s*(AM|PM)$/i.exec(t || "");
  if (!m) return -1;
  return ((Number(m[1]) % 12) + (m[3].toUpperCase() === "PM" ? 12 : 0)) * 60 + Number(m[2]);
};

// Merge open meetings into the hardcoded calendar days (by date), sorted by time.
export function mergeMeetings(calendar, meetings) {
  if (!meetings.length) return calendar;
  const days = calendar.map((d) => ({ ...d, events: [...d.events] }));
  meetings.forEach((m) => {
    const dt = new Date(`${m.date}T00:00:00`);
    const label = dt.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
    const ev = { t: to12h(m.start_time), e: m.title, v: m.venue || "", meeting: m };
    let day = days.find((d) => d.date === label);
    if (!day) {
      day = { date: label, day: dt.toLocaleDateString("en-US", { weekday: "long" }), events: [] };
      days.push(day);
    }
    day.events = day.events.filter((e) => e.e !== "No Schedule");
    day.events.push(ev);
    day.events.sort((a, b) => toMinutes(a.t) - toMinutes(b.t));
  });
  return days;
}
